<mat-nav-list [attr.aria-label]="ariaLabel()">
    <ng-content></ng-content>
</mat-nav-list>
